module.exports = __webpack_public_path__ + "img/post-thumb-4.60476136.png";